import React from "react";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import * as _ from "lodash";
import "./Header.css";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../store";
import { useLocation } from "react-router-dom";
import { logout } from "../../../store/slices/authSlice";
import { clearCurrentUser } from "../../../store/slices/userSlice";
import { clearAllAuthData } from "../../../Utilities/storageHelpers";

const Header: React.FC = () => {
  const user = useSelector((state: RootState) => state.user).currentUser;
  const dispatch = useDispatch();
  const location = useLocation();

  const getPageTitle = (): string => {
    const path = location.pathname;
    
    if (path === '/') return 'Dashboard';
    if (path.startsWith('/trails')) return 'Trail Management';
    if (path.startsWith('/users')) return 'User Management';
    if (path.startsWith('/reviews')) return 'Review Management';
    if (path.startsWith('/waypoints')) return 'Waypoint Management';
    
    // Handle specific trail pages
    if (path.includes('/trail/edit/')) return 'Edit Trail';
    if (path.includes('/trail/new')) return 'Create New Trail';
    
    return 'Admin Panel';
  };

  const LogOutUser = async () => {
    console.log("Logging out...");
    dispatch(logout());
    dispatch(clearCurrentUser());
    clearAllAuthData();
  };

  const getUserDisplayName = (): string => {
    if (!user) return 'Admin';
    
    return user.firstName && user.lastName 
      ? `${user.firstName} ${user.lastName}`
      : user.name || user.username || user.email?.split('@')[0] || 'Admin';
  };

  return (
    <div className="admin-header">
      <Navbar bg="white" className="admin-navbar px-0">
        <Container fluid className="px-4">
          <div className="page-title-section">
            <h1 className="page-title">{getPageTitle()}</h1>
          </div>
          
          <Nav className="ms-auto">
            {!_.isEmpty(user) && (
              <div className="d-flex align-items-center">
                <span className="welcome-text me-3">
                  Welcome, <strong>{getUserDisplayName()}</strong>
                </span>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={LogOutUser}
                  className="logout-btn"
                >
                  <i className="fas fa-sign-out-alt me-1"></i>
                  Log Out
                </Button>
              </div>
            )}
          </Nav>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
